// Copyright (c) 2018 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import informationRequestForm from './information-request-form';
import isFormDirty from './is-form-dirty';
import partRequestForm from './part-request-form';
import partReturn from './part-return';
import pictureRequestForm from './picture-request-form';

export const getCombinedReducers = () =>
    combineReducers({
        busyCounter,
        informationRequestForm,
        isFormDirty,
        partRequestForm,
        partReturn,
        pictureRequestForm
    });



// WEBPACK FOOTER //
// ./src/part-requests/request-details/reducers/index.js